import {
  FileCsv,
  FileImage,
  FileJpg,
  FilePdf,
  FilePng,
  FileXls,
  FileZip,
} from '@phosphor-icons/react';

import { MimeType } from 'core/enums';

export const fileTypeIconMap = {
  [MimeType.XLS]: <FileXls style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.XLSX]: <FileXls style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.CSV]: <FileCsv style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.PDF]: <FilePdf style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.JPEG]: <FileJpg style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.PNG]: <FilePng style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.GIF]: <FileImage style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.SVG]: <FileImage style={{ fill: 'inherit', fontSize: 'inherit' }} />,
  [MimeType.ZIP]: <FileZip style={{ fill: 'inherit', fontSize: 'inherit' }} />,
};

export const FileTypeLabelMap: Record<MimeType, string> = {
  [MimeType.XLS]: 'Excel',
  [MimeType.XLSX]: 'Excel',
  [MimeType.CSV]: 'CSV',
  [MimeType.PDF]: 'PDF',
  [MimeType.JPEG]: 'JPEG',
  [MimeType.PNG]: 'PNG',
  [MimeType.GIF]: 'GIF',
  [MimeType.SVG]: 'SVG',
  [MimeType.ZIP]: 'ZIP',
};
